import Reflux from "reflux";

export const ActionsDataViz = Reflux.createActions({
  loadDataVizCampaignData: { asyncResult: true },
  getDataVizChannelCampaignsByCampaignId: { asyncResult: true },
  getDataVizAdsetsByCampaignId: { asyncResult: true },
  selectChannel: {},
  selectOptions: {},
  metricHovered: {},
  setMetricsToUse: {},
  setInteractionMetrics: {}
});
